// extracted by mini-css-extract-plugin
export default {"heading":"Navbar__heading__YHp2C"};